import { OverMaximumStake } from '../general/over-maximum-stake';
import { PreCheckErrorMixin } from './pre-check-error';

export class OverMaximumStakePreCheckError extends PreCheckErrorMixin(OverMaximumStake) {
    constructor(
        readonly maximumStake: number,
        readonly betStake: number,
        readonly numberOfBetsInBet: number,
    ) {
        super();
    }

    getMaximumStake = () => this.maximumStake;
}
